/**
 * mulberry32 — a tiny, fast, seeded pseudo-random number generator.
 *
 * Given the same 32-bit seed it always yields the same sequence, which is what
 * lets the server and the client reproduce the exact same shuffle order during
 * hydration. Returns a function producing floats in [0, 1), suitable as the
 * `random` argument of {@link shuffle}.
 *
 * @param seed Any integer; coerced to an unsigned 32-bit value.
 */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Generate a fresh, unsigned 32-bit seed. */
export function makeSeed(): number {
  return (Math.random() * 0xffffffff) >>> 0;
}
